import { NewResponsibleOutDto, NewResponsibleInDto } from '../../../types/responsible.dto'

export const NEW_RESPONSIBLE = 'NEW_RESPONSIBLE'
export const NEW_RESPONSIBLE_SUCCESS = 'NEW_RESPONSIBLE_SUCCESS'
export const NEW_RESPONSIBLE_ERROR = 'NEW_RESPONSIBLE_ERROR'
export const RESET_NEW_RESPONSIBLE = 'RESET_NEW_RESPONSIBLE'

export interface NewResponsible {
  type: typeof NEW_RESPONSIBLE
  payload: NewResponsibleOutDto
}

export interface NewResponsibleSuccess {
  type: typeof NEW_RESPONSIBLE_SUCCESS
  payload: NewResponsibleInDto
}

export interface NewResponsibleError {
  type: typeof NEW_RESPONSIBLE_ERROR
  payload: string | boolean
}

export interface ResetNewResponsible {
  type: typeof RESET_NEW_RESPONSIBLE
  payload: null
}

export interface State {
  data: NewResponsibleInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = NewResponsible | NewResponsibleSuccess | NewResponsibleError | ResetNewResponsible
